interface ILanguages {
  languages: string[];
  default: string;
}

export const getLanguages = (): ILanguages => {
  try {
    return JSON.parse(import.meta.env.VITE_LANGUAGE_SETTINGS);
  } catch (e) {
    return {
      default: "en",
      languages: [],
    };
  }
};
